var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"components"},[_c('div',{staticClass:"back_btn row_center",on:{"click":_vm.backTop}},[_vm._v("回到顶部")])])
}
var staticRenderFns = []

export { render, staticRenderFns }